import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rel-investimentos',
  templateUrl: './rel-investimentos.component.html',
  styleUrls: ['./rel-investimentos.component.css']
})
export class RelInvestimentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
